var $$ = $$ || {};

$$.PartnerForm = class PartnerForm {
	constructor (root) {
		this.root = root;

		this._bindEvents();
		this._cacheNodes();
		this._ready();
	}

	_cacheNodes () {
		this.nodes = {
			form: this.root.find('.js-form')
		};
	}

	_bindEvents () {

	}

	_ready () {
		this.nodes.form.validate({
			submitHandler: (form) => {
				form = $(form);

				$.ajax({
					url:     form.attr('action'),
					method:  form.attr('method'),
					data:    form.serialize(),
					success: (response) => {
						response = $.parseJSON(response);

						if (response.success) {
							$$.Noty[ 'successMessage' ](response.success);
							this.root.trigger('partnerFormSubmit');
						} else {
							_.each(response.errors, function (value, key) {
								var input = form.find(`input[name="${key}"]`).addClass('error');
								var error = $('<label class="error">' + value + '</label>');

								error.insertAfter(input);
							});
						}
					}
				});
			}
		});
	}
};
